import { useEffect, useRef } from 'react'
import { useAuth } from '@clerk/clerk-react'
import { recordSession, type SignInMethod } from '@/api/users'
import { PENDING_SIGN_IN_METHOD_KEY } from '@/lib/pendingSignInMethod'

/** Mounted once at the app root. No-op unless markPendingSignInMethod() was called earlier in
 *  this tab and a session has since become active. */
export function PendingSessionRecorder() {
  const { isSignedIn } = useAuth()
  const recorded = useRef(false)

  useEffect(() => {
    if (!isSignedIn || recorded.current) return
    const method = sessionStorage.getItem(PENDING_SIGN_IN_METHOD_KEY) as SignInMethod | null
    if (!method) return
    recorded.current = true
    sessionStorage.removeItem(PENDING_SIGN_IN_METHOD_KEY)
    recordSession(method).catch(() => {})
  }, [isSignedIn])

  return null
}
